import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input } from 'antd';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { emailAsciiRule } from 'app/utils/rules';

import { FieldValue } from '../FieldView/FieldView';

import styles from './BillingContact.module.scss';

const BILLING_EMAILS_FIELD = 'billingEmails';

export const BillingContact = ({ isEditMode }: { isEditMode: boolean }) => (
  <Form.List name={BILLING_EMAILS_FIELD}>
    {(fields, { add, remove }) => (
      <>
        {fields.map(({ key, name, ...restField }) => (
          <div key={key} className={styles.emailRow}>
            <FormLineLayout
              label="Email"
              isRequired={isEditMode && (fields.length === 1 || key === 0)}
            >
              <Form.Item
                {...restField}
                name={name}
                rules={
                  isEditMode
                    ? [
                        { required: true, message: 'Email is required' },
                        emailAsciiRule,
                      ]
                    : undefined
                }
              >
                {isEditMode ? <Input type="email" /> : <FieldValue />}
              </Form.Item>
            </FormLineLayout>
            {isEditMode && fields.length > 1 && key !== 0 && (
              <DeleteOutlined
                className={styles.deleteIcon}
                onClick={() => remove(name)}
              />
            )}
          </div>
        ))}
        {!isEditMode && fields.length === 0 && (
          <FormLineLayout label="Email">
            <FieldValue />
          </FormLineLayout>
        )}
        {isEditMode && (
          <Button
            className={styles.addButton}
            icon={<PlusOutlined />}
            onClick={() => add()}
            size="middle"
          >
            Add email
          </Button>
        )}
      </>
    )}
  </Form.List>
);
